import type { ValidationRule } from './rules';
import type { ConfiguredValidationRules, ValidationResult, ValidationRuleConfig } from './types';
import { VALIDATORS } from './validators';

const checkRule = (
  rule: ValidationRule,
  config: ValidationRuleConfig,
  value: string
): ValidationResult => {
  const validator = VALIDATORS[rule];
  if (!validator) {
    return null;
  }

  const error = validator(config, value);
  if (!error) {
    return null;
  }

  if (typeof error === 'string') {
    return {
      rule,
      message: error,
    };
  }
  if (typeof error === 'object') {
    return error;
  }

  return null;
};

export const validate = (rules: ConfiguredValidationRules, value: string): ValidationResult => {
  if (!rules) {
    return null;
  }

  const errors = Object.entries(rules)
    // Skip rules with falsy value
    .filter(([, ruleValue]) => Boolean(ruleValue))
    // Apply rules
    .map(([ruleName, ruleValue]) => checkRule(ruleName, ruleValue, value))
    // Filter out rules without errors
    .filter((error) => Boolean(error));

  // return just the first error
  return errors[0] || null;
};
